function TableToggle({ checked, disabled, onChange, ariaLabel }) {
  return (
    <label
      className={`toggle-switch toggle-switch--table ${checked ? 'is-on' : ''}`}
      aria-label={ariaLabel}
    >
      <input
        type="checkbox"
        checked={Boolean(checked)}
        disabled={disabled}
        onChange={(e) => onChange(e.target.checked)}
      />
      <span className="toggle-switch__slider" aria-hidden="true" />
    </label>
  );
}

export default TableToggle;
